import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { BsList } from "react-icons/bs";
import {
  FaTimes,
  FaHome,
  FaListAlt,
  FaPlus,
  FaInfoCircle,
  FaRegUser,
  FaClipboardList,
  FaCog,
  FaUserShield,
  FaSignOutAlt,
} from "react-icons/fa";
import HeaderLogo from "../header-logo/HeaderLogo";
import { decodeWithSalt } from "../../../utils/encodeFunctions";
import { UserRole } from "../../../enums/UserRole";
import "./header-popup.css";

function HeaderPopup() {
  const [open, setOpen] = useState(false);

  const location   = useLocation();
  const isLoggedIn = decodeWithSalt(sessionStorage.getItem("loggedIn") ?? "");
  const role       = decodeWithSalt(sessionStorage.getItem("role")      ?? "");
  const isAdmin    = role === UserRole.ROOT || role === UserRole.ADMIN;

  function close() { setOpen(false); }

  function handleLogout() {
    sessionStorage.clear();
    close();
  }

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <>
      <button
        className="bg-transparent border-0 p-0 d-flex align-items-center"
        onClick={() => setOpen(true)}
        aria-label="Open menu"
      >
        <BsList size={28} color="white" />
      </button>

      {/* Backdrop */}
      {open && <div className="side-drawer-backdrop" onClick={close} />}

      {/* Drawer */}
      <div className={`side-drawer${open ? " side-drawer--open" : ""}`} aria-hidden={!open}>

        {/* Red header */}
        <div className="side-drawer__header">
          <HeaderLogo />
          <button className="side-drawer__close" onClick={close} aria-label="Close menu">
            <FaTimes size={18} />
          </button>
        </div>

        {/* Nav items */}
        <nav className="side-drawer__nav">
          {location.pathname !== "/" && (
            <Link to="/" onClick={close} className="side-drawer__item">
              <FaHome size={16} className="side-drawer__icon" />
              Home
            </Link>
          )}

          {location.pathname !== "/ads" && (
            <Link to="/ads?page=1" onClick={close} className="side-drawer__item">
              <FaListAlt size={16} className="side-drawer__icon" />
              All Ads
            </Link>
          )}

          <Link to="/create-ad" onClick={close} className="side-drawer__item">
            <FaPlus size={16} className="side-drawer__icon" />
            Post Free Ad
          </Link>

          <Link to="/about-us" onClick={close} className="side-drawer__item">
            <FaInfoCircle size={16} className="side-drawer__icon" />
            About Us
          </Link>

          <div className="side-drawer__divider" />

          {isLoggedIn ? (
            <>
              <Link to="/ad-settings" onClick={close} className="side-drawer__item">
                <FaClipboardList size={16} className="side-drawer__icon" />
                My Ads
              </Link>

              <Link to="/profile-settings" onClick={close} className="side-drawer__item">
                <FaCog size={16} className="side-drawer__icon" />
                Profile Settings
              </Link>

              {isAdmin && (
                <Link to="/admin/dashboard" onClick={close} className="side-drawer__item">
                  <FaUserShield size={16} className="side-drawer__icon" />
                  Admin Console
                </Link>
              )}

              <div className="side-drawer__divider" />

              <Link to="/" onClick={handleLogout} className="side-drawer__item side-drawer__item--danger">
                <FaSignOutAlt size={16} className="side-drawer__icon" />
                Logout
              </Link>
            </>
          ) : (
            <Link to="/login" onClick={close} className="side-drawer__item">
              <FaRegUser size={16} className="side-drawer__icon" />
              Sign In
            </Link>
          )}
        </nav>

      </div>
    </>
  );
}

export default HeaderPopup;
